import React, { Fragment } from 'react';
import { Row } from 'react-bootstrap';
import { SSection, SContainer, STitle, SDescription } from './styles';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import BlogPostCard from 'components/BlogPostCard';
import { getImage } from 'gatsby-plugin-image';
import { SlidePostContainer } from './SlidePostContainer';
import 'glider-js/glider.min.css';

/**
 * Renders an array of `blogPosts` in a container in blog post cards, with a title and description for the container
 * @param {object} props
 * @property {string} props.title The title of the blog posts section
 * @property {string} props.description A description of this section on the page being used at
 * @property {array} props.blogPosts An array of blog posts
 * @returns
 */

function BlogPosts({
  title,
  description,
  blogPosts,
  inversePostCards = true,
  isPodcasts = false,
  isSlider = false,
}) {
  const defaultTitle = <>Expert Knowledge</>;

  const defaultDescription = (
    <>
      Learn from our experts and other landlords in the rental market.{' '}
      <Link to="/blog/">Start Reading</Link>
    </>
  );

  const shouldShowSlider = isSlider && blogPosts.length >= 4;

  return (
    <SSection>
      <SContainer>
        {<STitle> {title || defaultTitle}</STitle>}
        {<SDescription>{description || defaultDescription}</SDescription>}
        <Row className="mt-3">
          <SlidePostContainer isSlide={isSlider}>
            {blogPosts.map((post, idx) => {
              const image = post.featuredImage
                ? getImage(post.featuredImage.node.localFile)
                : null;

              return (
                <BlogPostCard
                  key={idx}
                  postUrl={
                    isPodcasts
                      ? `/podcast/${post.slug}/`
                      : `/blog/${post.slug}/`
                  }
                  imageAlt={post.title}
                  postDate={post.date}
                  postTitle={post.title}
                  excerpt={post?.seo.metaDesc}
                  postReadingTime={post?.seo.readingTime}
                  image={image}
                  mdCol={shouldShowSlider ? '12' : '6'}
                  lgCol={shouldShowSlider ? '12' : '3'}
                  height="150"
                  hideReadingTime
                  categories={post?.categories.nodes}
                  // This card is inverted, as a default
                  inverse={inversePostCards}
                  isPodcast={isPodcasts}
                />
              );
            })}
          </SlidePostContainer>
        </Row>
      </SContainer>
    </SSection>
  );
}

BlogPosts.propTypes = {
  blogPosts: PropTypes.array,
  children: PropTypes.node,
  description: PropTypes.node,
  title: PropTypes.node,
  inversePostCards: PropTypes.bool,
  isPodcasts: PropTypes.bool,
  isSlider: PropTypes.bool,
};

export default BlogPosts;
